export const CommuitySettingsSetupDetailsDetails = [
    {
        title: 'Customize your community settings',
        content: 'Learn and Customize community URL, timezone, privacy, setting logo and more.',
    },
];
